import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/sharp-light-svg-icons";
import { Box, BoxProps, Typography, styled } from "@mui/material";
import { ReactNode } from "react";

interface ContainerProps extends BoxProps {
    visible?: boolean;
    height?: string;
}

const SidebarItemContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== "visible" && prop !== "height",
})<ContainerProps>(({ visible, height }) => ({
    height: visible && height && height !== "full" ? height : "auto",
    flex: visible && height && height === "full" ? 1 : "unset",
    color: "#545454",
    display: "flex",
    flexDirection: "column",
    maxHeight: height === "full" ? "100%" : height,
}));

const HeaderContainer = styled("div")(({ theme }) => ({
    display: "flex",
    cursor: "pointer",
    alignItems: "center",
    borderBottomWidth: 1,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    color: "#615c5c",
    height: 45,
    "& svg": {
        fill: "#707070",
        width: "1rem",
        height: "1rem",
        marginRight: theme.spacing(1),
    },
    "&:last-child": {
        borderBottomWidth: 0,
    },
}));

interface SidebarItemProps {
    title: string;
    height?: string;
    icon: IconDefinition;
    visible?: boolean;
    onChange?: (bool: boolean) => void;
    children: ReactNode;
}

const SidebarItem = ({ visible, icon, title, children, height, onChange }: SidebarItemProps) => {
    return (
        <SidebarItemContainer visible={visible} height={height}>
            <HeaderContainer
                onClick={() => {
                    if (onChange) onChange(!visible);
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                    <FontAwesomeIcon icon={icon} />
                    <Typography sx={{ textTransform: "uppercase", fontSize: "0.75rem" }}>{title}</Typography>
                </Box>
                <FontAwesomeIcon icon={visible ? faChevronUp : faChevronDown} style={{ width: 8, height: 8 }} />
            </HeaderContainer>
            {visible && <Box sx={{ width: "100%", flex: 1, overflow: "auto" }}>{children}</Box>}
        </SidebarItemContainer>
    );
};

export default SidebarItem;
